import { checkNull, CodeList, ReportContainer } from "../constant";

interface CptCodesBlockProps {
  data: any;
}

const CptCodesBlock = ({ data }: CptCodesBlockProps) => {
  if (!checkNull(data?.procedureCodes)) return null;

  // Header and code alignment mirror the Psychiatric Progress Exam report so
  // the Plan section reads the same across every note type. `flow` keeps the
  // block's height tied to the number of codes: it continues on the next page
  // when it no longer fits rather than being pushed there whole.
  return (
    <ReportContainer label="CPT Code" flow>
      <CodeList codes={data?.procedureCodes} />
    </ReportContainer>
  );
};

export default CptCodesBlock;
